// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mediasfu-customButtonsContainer {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: left;
}

.mediasfu-customButtonsContainer .customButton {
  width: 100%;
  margin: 10px 0;
  padding: 10px;
  border-radius: 5px;
  background-color: transparent;
  align-items: left;
  justify-content: left;
  border: none;
}

.mediasfu-customButtonsContainer .buttonContent {
  display: flex;
  align-items: left;
  justify-content: left;
}

.mediasfu-customButtonsContainer .customButtonIcon {
  font-size: 20px;
  color: #000000; /* Default color for the button icon */
  margin-right: 4px;
}

.mediasfu-customButtonsContainer .customButtonText {
  color: #000000; /* Default color for the button text */
}
`, "",{"version":3,"sources":["webpack://./src/components/menuComponents/CustomButtons.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc,EAAE,sCAAsC;EACtD,iBAAiB;AACnB;;AAEA;EACE,cAAc,EAAE,sCAAsC;AACxD","sourcesContent":[".mediasfu-customButtonsContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex-wrap: wrap;\r\n  justify-content: space-between;\r\n  align-items: left;\r\n}\r\n\r\n.mediasfu-customButtonsContainer .customButton {\r\n  width: 100%;\r\n  margin: 10px 0;\r\n  padding: 10px;\r\n  border-radius: 5px;\r\n  background-color: transparent;\r\n  align-items: left;\r\n  justify-content: left;\r\n  border: none;\r\n}\r\n\r\n.mediasfu-customButtonsContainer .buttonContent {\r\n  display: flex;\r\n  align-items: left;\r\n  justify-content: left;\r\n}\r\n\r\n.mediasfu-customButtonsContainer .customButtonIcon {\r\n  font-size: 20px;\r\n  color: #000000; /* Default color for the button icon */\r\n  margin-right: 4px;\r\n}\r\n\r\n.mediasfu-customButtonsContainer .customButtonText {\r\n  color: #000000; /* Default color for the button text */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
